import { ApiCall } from '../services/http-service/types/ApiCall';
import httpService, { authHttpService } from '../services/http-service';
import { RefreshableHttpServiceConfigurator } from '../services/http-service/refreshable-http-service-configurator';
import { ChangePasswordParams } from './types/ChangePasswordParams';
import { UserCompany } from './types/UserCompany.types';

declare global {
  interface Window {
    FS: any;
  }
}

/**
 * Change password with confirm old one
 */
export const changePassword: ApiCall<ChangePasswordParams, void> = async ({ params, abortSignal }) => {
  await authHttpService.put('/api/v1/password', params, abortSignal);
};

/**
 * Reset password with new password only
 */
export const resetPassword = async (params: {
  password: string;
  reset_password_token: string;
}) => {
  const res = await authHttpService.put('/api/v1/reset-password', params);
  return res.data;
};

/**
 * Send email with reset password token
 */
export const requestResetPassword = async (params: {
  email: string;
  redirect_url: string;
}) => {
  const res = await authHttpService.post('/api/v1/reset-password', params);
  return res.data;
};

/**
 * Signin request with email and password
 */
export const signIn = async (values: { email: string; password: string }): Promise<{force_change_password: boolean}> => {
  const { data } = await authHttpService.post('/api/v1/email-auth',
    { ...values }
  );
  return data;

};

/**
 * Invalidate token and close session
 */
export const signOut = async () => {
  const headers = RefreshableHttpServiceConfigurator.getRefreshTokenHeaders();
  await authHttpService.delete('/api/v1/token', null, undefined, headers).catch(() => ({}));
};

/**
 * Check if existing token is valid and return user data
 */
export const checkUser = async () => {
  const { data } = await httpService.get('/api/v2/profile/extended');
  return data;
};

/**
 * Refresh access token
 */
export const refreshAccessToken = () => {
  const headers = RefreshableHttpServiceConfigurator.getRefreshTokenHeaders();
  return authHttpService.post('/api/v1/token', null, undefined, headers);
};

/**
 * remove user from impersonate
 */
export const backFromImpersonate = async () => {
  const headers = RefreshableHttpServiceConfigurator.getRefreshTokenHeaders();
  await authHttpService
    .put('/api/v1/token/rollback', null, undefined, headers);
};

export const impersonateUser: ApiCall<{ userId: number }, void> =
  async ({ params, abortSignal }) => {
    const headers = RefreshableHttpServiceConfigurator.getRefreshTokenHeaders();
    const { data } = await httpService.post(
      `/user-management/api/v3/users/${params.userId}/impersonate`,
      null,
      abortSignal,
      headers
    );
    return data;
  };

export const getUserCompanies: ApiCall<null, UserCompany[]> = async ({ abortSignal }) => {
  const { data } = await httpService.get(
    '/api/v3/account/authorization/companies',
    null,
    abortSignal,
  );
  return data;
};
